import React, { Component } from 'react';
//import LoadManagerCenter from './loadManager/LoadManagerCenter';
import loadsStore from '../../../stores/loads-store';
import { ScaleLoader } from 'react-spinners';
import './index.css'
import {withRouter} from 'react-router-dom';

// import ViewDetail from './modals/jumperDetail';
import {
     Col, Row
} from 'reactstrap';
import jumpersStore from '../../../stores/jumpers-store';
import accountStore from '../../../stores/account-store';

import BottomNav from '../bottomNav';
import ChargeJumper from './ChargeJumper'
class DailyActivity extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            showModal: false,
            isLoading: true,
            dailyActivity: {},
            cardsOnFile:[],
            accountOnFile: [],
            jumperId: null,
            isTandemStudent: false,
        }
        this.jumperEvents = [
            { name: jumpersStore.getEventPrefix('dailyActivity'), func: this.handleDailyActivity },
            { name: jumpersStore.getEventPrefix('jumpersLoaded'), func: this.handleJumperLoading },
        ];
        this.accountEvents = [
            { name: accountStore.getEventPrefix('chargeAdded'), func: this.afterChargeJumper },
        ]
    }

    componentDidMount() {
        this.jumperEvents.forEach((evnt) => jumpersStore.on(evnt.name, evnt.func));
        this.accountEvents.forEach((evnt) => accountStore.on(evnt.name, evnt.func));

        window.MainApp = this;
        let jumperId = this.returnJumperId();
        if(jumperId!==null){
            jumpersStore.getJumperDetails(jumperId).then(res => {
            // // console.log("🚀 ~ file: index.js ~ line 44 ~ DailyActivity ~ jumpersStore.getJumperDetails ~ res", res)
                this.setState({
                    dailyActivity: res.dailyActivity,
                    jumperId,
                })
            })
        }
    }
    componentWillUnmount() {
        this.jumperEvents.forEach((evnt) => jumpersStore.removeListener(evnt.name, evnt.func));
        this.accountEvents.forEach((evnt) => accountStore.removeListener(evnt.name, evnt.func));
    }

    IsEnableLoader = (value) => {
        //value from index.html
        this.setState({isLoading:value})
    }
    returnJumperId = () => {
        let jumperDetails = localStorage.getItem('jumperDetails')
        // console.log("🚀 ~ file: index.js ~ line 41 ~ DailyActivity ~ componentDidMount ~ jumperDetails", jumperDetails)
        if (jumperDetails != 'undefined') {
            jumperDetails = JSON.parse(jumperDetails)
            return jumperDetails._id;
        }
        else {
            return null;
        }
    }
    afterChargeJumper = (resObj) => {
        this.setState({dailyActivity:resObj.dailyActivity})
    }
    componentDidUpdate() {
        // console.log('GIFTCARD: ', this.state.cardsOnFile);
        if (this.state.isLoading) {
            let jumperId = this.returnJumperId();
            if (jumperId !== null) {
                let jumper = jumpersStore.getCardDetails(jumperId);
                if (jumper.length > 0) {
                    this.setState({
                        cardsOnFile: jumper[0].cardsOnFile,
                        isLoading:false,
                    })
                }
            }
        }
    }
    handleJumperLoading = () => {
        let jumperId = this.returnJumperId();
        if (jumperId !== null) {
            let jumper = jumpersStore.getCardDetails(jumperId);
            if (jumper.length > 0) {
                jumpersStore.getJumperDetails(jumperId).then(res => {
                    // // console.log("🚀 ~ file: index.js ~ line 44 ~ DailyActivity ~ jumpersStore.getJumperDetails ~ res", res)
                    this.setState({
                        dailyActivity: res.dailyActivity,
                        jumperId,
                        isLoading: false,
                        cardsOnFile: jumper[0].cardsOnFile,
                    })
                })
            }
        }
    }
    handleDailyActivity = (data) => {

		var cardsOnFile =[];
		var accountOnFile=[];
		if(!data.isTandemStudent){
			cardsOnFile = jumpersStore.getJumperById(data.jumperId).cardsOnFile;
			accountOnFile = jumpersStore.getJumperById(data.jumperId).accountOnFile;
		}
		else{
			debugger;
			var tandemStudent = jumpersStore.getTandemStudentById(data.jumperId);
			if(tandemStudent !== undefined){
				cardsOnFile=jumpersStore.getTandemStudentById(data.jumperId).cardOnFile;
			}

		}
		// console.log(data.dailyActivity);
		this.setState({
			dailyActivity: data.dailyActivity,
			otherActivities: data.otherActivities,
			jumperId: data.jumperId,
			isTandemStudent: data.isTandemStudent,
			isLoading: false,
			cardsOnFile: cardsOnFile,
			accountOnFile: accountOnFile
		});
		var stateObj = {
				dailyActivity: data.dailyActivity,
				otherActivities: data.otherActivities,
				jumperId: data.jumperId,
				isTandemStudent: data.isTandemStudent,
				isLoading: false,
			}
		if(cardsOnFile){
			stateObj.cardsOnFile = cardsOnFile;
		}
		this.setState(stateObj);

		if(this.props.tandems && data.dailyActivity.isTandemStudent || !this.props.tandems && data.dailyActivity.jumperId!==undefined){
			this.setState({ isModalOpen: true});
		}
		//this.setState({ isModalOpen: true});

	}

    // componentWillMount() {
    //     this.jumperEvents.forEach((evnt) => jumpersStore.on(evnt.name, evnt.func));
    // }

    // handleJumpersLoaded = (jumperOptions) => {
    //     //console.log('in handleLoadPilots');
    //     this.setState({
    //         jumperOptions: jumperOptions
    //     });
    // }
    // handleLogout() {
    //     localStorage.clear();
    //     clearInterval(loadsStore.scrollTimer)
    //     clearInterval(loadsStore.scrollTimer1)
    //     this.props.history.push('/login')
    // }
    // isLoading = (data) => {
    //     this.setState({
    //         loading: data
    //     })
    // }

    renderSummary() {
        var counterSalesPrice = 0;
        var countersales = null;
        if (this.state && this.state.dailyActivity && this.state.dailyActivity.countersales) {
            countersales = this.state.dailyActivity.countersales.map(sale => {
                counterSalesPrice = counterSalesPrice + sale.price;
                // return(<p style={{textAlign:'left',paddingLeft:'8px'}}><div style={{width:'134px !important',display:'inline-block'}}>{sale.item.toUpperCase()}</div> : {sale.count} : ${sale.price}</p>)
                if (sale.item != undefined) {
                    return (
                        <React.Fragment>
                            <tr><td>{sale.item !== undefined ? sale.item.toUpperCase() : 'Item'}</td> <td> {sale.count}</td> <td> {this.checkForNegatives(sale.price)}</td>{sale.item !== "transfer" ? <td><button className="btn lightBlueButton"
                            // onClick={() => accountStore.DeleteItem(this.state.jumperId, sale._id)}
                            ><i className="fa fa-times" /> </button></td> : null}</tr>
                            {sale.description !== undefined ? <tr><td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{sale.description}</td></tr> : ''}
                            {sale.memo !== undefined && sale.memo !== "" ? this.renderMemo(sale.memo) : null}
                        </React.Fragment>
                    )
                }
            });
        }

        var charges = null;
        if (this.state && this.state.dailyActivity && this.state.dailyActivity.charges) {
            charges = this.state.dailyActivity.charges.map(charge => {

                if (charge.amount !== undefined) {
                    return (
                        <React.Fragment>
                            <tr><td>{charge.amount !== undefined && !charge.isRefund ? 'CHARGE' : 'REFUND'}</td>
                                <td></td>
                                <td>{this.checkForNegatives(charge.amount)}</td>
                                {
                                    !charge.isRefund ?
                                        <td>
                                            {/* <button className="btn lightBlueButton" onClick ={() => this.refundJumper(charge)}>
										<i className="fa fa-undo" />
									</button> */}
                                            {/* <RefundConfirMation jumperId={this.state.jumperId} chargeValue={charge} /> */}
                                        </td>
                                        : null
                                }</tr>
                            <tr><td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{charge.transactionType.toUpperCase()}</td></tr>
                            {charge.memo ? this.renderMemo(charge.memo) : null}
                        </React.Fragment>
                    )
                }
            });
        }

        let { dailyActivity } = this.state;
        if (dailyActivity) {
            return<div>
                <h4 className="titleMain">{dailyActivity.name}</h4>
                {/* <table className="StaffSummary StaffSummary" style={{ marginLeft: '6px', width: '97%', height: '200px', display: 'inline-block', overflow: 'auto' }}> */}
                <table className="StaffSummary accountSummary">
                    <tbody>
                        {dailyActivity.tandemStudentJumps > 0 ?
                            <tr>
                                <td>TANDEMS</td>
                                <td>{dailyActivity.tandemStudentJumps}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                                <td>{this.checkForNegatives(dailyActivity.tandemValue)}</td>
                            </tr>
                            : null}
                        {dailyActivity.tandemStudentJumps > 0 && dailyActivity.videos !== 0 ?
                            <tr>
                                <td>TANDEM VIDEOS</td>
                                <td>{dailyActivity.videos}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                                <td>{this.checkForNegatives(dailyActivity.videosValue)}</td>
                            </tr>
                            : null}
                        {dailyActivity.aff1 !== undefined && dailyActivity.aff1.count !== 0 ?
                            <tr>
                                <td>AFF 1 JUMPS</td>
                                <td>{dailyActivity.aff1.count}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                                <td>{this.checkForNegatives(dailyActivity.aff1.value)}</td>
                            </tr>
                            : null}
                        {dailyActivity.aff2_3 !== undefined && dailyActivity.aff2_3.count !== 0 ?
                            <tr>
                                <td>AFF 2-3 JUMPS</td>
                                <td>{dailyActivity.aff2_3.count}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                                <td>{this.checkForNegatives(dailyActivity.aff2_3.value)}</td>
                            </tr>
                            : null}
                        {dailyActivity.aff4_7 !== undefined && dailyActivity.aff4_7.count !== 0 ?
                            <tr>
                                <td>AFF 4-7 JUMPS</td>
                                <td>{dailyActivity.aff4_7.count}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                                <td>{this.checkForNegatives(dailyActivity.aff4_7.value)}</td>
                            </tr>
                            : null}
                        {dailyActivity.funJumps !== undefined && dailyActivity.funJumps.count !== 0 ?
                            <tr>
                                <td>FUN JUMPS</td>
                                <td>{dailyActivity.funJumps.count}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                                <td>{this.checkForNegatives(dailyActivity.funJumps.value)}</td>
                            </tr>
                            : null}
                        {dailyActivity.aff1Jumps !== undefined && dailyActivity.aff1Jumps.count !== 0 ?
                            <tr>
                                <td>AFF 1 INSTRUCTOR JUMPS</td>
                                <td>{dailyActivity.aff1Jumps.count}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                                <td>{this.checkForNegatives(dailyActivity.aff1Jumps.value)}</td>
                            </tr>
                            : null}
                        {dailyActivity.aff2_3Jumps !== undefined && dailyActivity.aff2_3Jumps.count !== 0 ?
                            <tr>
                                <td>AFF 2-3 INSTRUCTOR JUMPS</td>
                                <td>{dailyActivity.aff2_3Jumps.count}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                                <td>{this.checkForNegatives(dailyActivity.aff2_3Jumps.value)}</td>
                            </tr>
                            : null}
                        {dailyActivity.aff4_7Jumps !== undefined && dailyActivity.aff4_7Jumps.count !== 0 ?
                            <tr>
                                <td>AFF 4-7 INSTRUCTOR JUMPS</td>
                                <td>{dailyActivity.aff4_7Jumps.count}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                                <td>{this.checkForNegatives(dailyActivity.aff4_7Jumps.value)}</td>
                            </tr>
                            : null}

                        {dailyActivity.tandemJumps !== undefined && dailyActivity.tandemJumps.count !== 0 ?
                            <tr>
                                <td>TANDEM JUMPS</td>
                                <td>{dailyActivity.tandemJumps.count}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                                <td>{this.checkForNegatives(dailyActivity.tandemJumps.value)}</td>
                            </tr>
                            : null}

                        {dailyActivity.tandemUltraJumps !== undefined && dailyActivity.tandemUltraJumps.count !== 0 ?
                            <tr>
                                <td>TANDEM ULTRAS</td>
                                <td>{dailyActivity.tandemUltraJumps.count}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                                <td>{this.checkForNegatives(dailyActivity.tandemUltraJumps.value)}</td>
                            </tr>
                            : null}

                        {dailyActivity.videoJumps !== undefined && dailyActivity.videoJumps.count !== 0 ?
                            <tr>
                                <td>VIDEO JUMPS </td>
                                <td>{dailyActivity.videoJumps.count}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                                <td>{this.checkForNegatives(dailyActivity.videoJumps.value)}</td>
                            </tr>
                            : null}

                        {dailyActivity.withVideoJumps !== undefined && dailyActivity.withVideoJumps.count !== 0 ?
                            <tr>
                                <td>VIDEOS </td>
                                <td>{dailyActivity.withVideoJumps.count}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                                <td>{this.checkForNegatives(dailyActivity.withVideoJumps.value)}</td>
                            </tr>
                            : null}

                        {dailyActivity.coachJumps !== undefined && dailyActivity.coachJumps.count !== 0 ?
                            <tr>
                                <td>COACH JUMPS </td>
                                <td>{dailyActivity.coachJumps.count}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                                <td>{this.checkForNegatives(dailyActivity.coachJumps.value)}</td>
                            </tr>
                            : null}
                        {dailyActivity.coachedJumps !== undefined && dailyActivity.coachedJumps.count !== 0 ?
                            <tr>
                                <td>COACHED JUMPS </td>
                                <td>{dailyActivity.coachedJumps.count}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                                <td>{this.checkForNegatives(dailyActivity.coachedJumps.value)}</td>
                            </tr>
                            : null}


                        {dailyActivity.wingsuitCoachJumps !== undefined && dailyActivity.wingsuitCoachJumps.count !== 0 ?
                            <tr>
                                <td>WINGSUIT COACH JUMPS </td>
                                <td>{dailyActivity.wingsuitCoachJumps.count}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                                <td>{this.checkForNegatives(dailyActivity.wingsuitCoachJumps.value)}</td>
                            </tr>
                            : null}
                        {dailyActivity.wingsuitCoachedJumps !== undefined && dailyActivity.wingsuitCoachedJumps.count !== 0 ?
                            <tr>
                                <td>WINGSUIT COACHED JUMPS </td>
                                <td>{dailyActivity.wingsuitCoachedJumps.count}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                                <td>{this.checkForNegatives(dailyActivity.wingsuitCoachedJumps.value)}</td>
                            </tr>
                            : null}


                        {dailyActivity.hopnpops !== undefined && dailyActivity.hopnpops.count !== 0 ?
                            <tr>
                                <td>HOP N POPS </td>
                                <td>{dailyActivity.hopnpops.count}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                                <td>{this.checkForNegatives(dailyActivity.hopnpops.value)}</td>
                            </tr>
                            : null}

                        {dailyActivity.solos !== undefined && dailyActivity.solos.count !== 0 ?
                            <tr>
                                <td>SOLO </td>
                                <td>{dailyActivity.solos.count}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                                <td>{this.checkForNegatives(dailyActivity.solos.value)}</td>
                            </tr>
                            : null}

                        {dailyActivity.gearRentals !== undefined && dailyActivity.gearRentals.count !== 0 ?
                            <tr>
                                <td>GEAR RENTALS </td>
                                <td>{dailyActivity.gearRentals.count}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                                <td>{this.checkForNegatives(dailyActivity.gearRentals.value)}</td>
                            </tr>
                            : null}

                        {countersales}
                        {charges}

                        <tr style={{ visibility: 'hidden' }}>
                            <td>PREVIOUS BALANCE 	</td>
                            <td></td>
                            <td></td>
                        </tr>

                    </tbody>
                </table>

            </div>
        }
        else {
            return null
        }

    }
    renderMemo = (memo) => {
        return <tr><td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{"memo: " + memo}</td></tr>
    }

    checkForNegatives = (price) => {
        //console.log('check for negatives: ' + price);
        if (price != undefined) {
            let priceCell = (price < 0) ?
                {
                    value: `($${Math.abs(price).toFixed(2)})`
                } :
                {
                    value: `$${price.toFixed(2)}`
                }

            if (price < 0) {
                return <span style={{ color: 'red' }}> {priceCell.value}</span>;
            }
            return priceCell.value;
        }
        else {
            return '$0.00';
        }
    }
    navigateToDetail=()=>{
        this.props.history.push({
            pathname:'/daily-activity/details',
        })
    }

    render() {
        let { jumperId, dailyActivity } = this.state
        const override = `
	        display: block;
	        margin: 0 auto;
	        border-color: red;
          `;
        if (dailyActivity) {
            var todayBalanceString = this.checkForNegatives(dailyActivity.todayBalance)
            var totalPaidString = this.checkForNegatives(dailyActivity.todayPaid)
        }

        return (
            <div className="col bodyView" style={{ height: '100vh' }}>
                {this.state.isLoading?(
                    <div style={{ position: 'absolute', left: '48%', top: '40%', zIndex: '999999' }}>
                        <div className='sweet-loading'>
                        <ScaleLoader
                            height={35}
                            width={8}
                            margin={'2px'}
                            radius={2}
                            color={'#123abc'}
                            />
                        <p>Please wait...</p>
                        </div>
                    </div>
                ):(
                <div className="mainContainer daily-activity">

                    <h2 className="heading">View Daily Activity</h2>

                    <Row className="form-group">
                        <Col md={12}>
                            {this.renderSummary()}
                        </Col>
                    </Row>

                    <div className="ViewAccounts-totalSection-246" style={{ paddingTop: 10, paddingBottom: 10 }}>

                        <table className="StaffSummary">
                            <tbody>
                                <tr>
                                    <td>TODAYS BALANCE </td>
                                    <td> {todayBalanceString !== "($undefined)" ? todayBalanceString : "$0"}</td>
                                </tr>
                                <tr>
                                    <td>TOTAL PAID </td>
                                    <td>{totalPaidString !== "($undefined)" ? totalPaidString : "$0"}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <Row style={{ marginTop: 10 }}>
                        <Col sm={12} xs={12} md={12}>
                            {
                            jumperId !== '' &&
                            <button className="btn customButton rightButton" style={{ borderRadius: '4px', backgroundColor: '#A7F6FF', color: '#082764' }}
                                onClick={()=>this.navigateToDetail()}
                            >
                            View Details
                            </button>
                            }
                        </Col>
                        <Col sm={12} xs={12} md={12}>
                            {
                            jumperId !== '' &&
                            <ChargeJumper jumperId={this.state.jumperId}
									token={this.state.cardsOnFile}
									accountOnFile={this.state.accountOnFile}
									value={
										dailyActivity.totalDue > 0
										? Number(dailyActivity.totalDue).toFixed(2)
										: Number(dailyActivity.totalBalance).toFixed(2)
									}
									isTandemStudent={this.state.isTandemStudent}
							/>
                            }
                        </Col>
                    </Row>
                    <Row className="displayBtnOnMobile form-group">
                        <Col md={{ size: 9 }}>
                            <button
                                onClick={() => this.props.history.push({ pathname: '/', initial: true })}
                                className="btn btn-link"
                            >
                                Back
                            </button>
                        </Col>
                    </Row>
                </div>
                )}
                <BottomNav  history={this.props.history} componentToRender={0} />
            </div>
        );
    }
}

export default withRouter(DailyActivity);
